import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("scratch_token");
    if (!token) { setLoading(false); return; }
    api.get("/session").then(({ data }) => {
      setUser(data.user);
      setCourse(data.course);
    }).finally(() => setLoading(false));
  }, []);

  const login = async () => {
    const { data } = await api.post("/auth/demo-login");
    localStorage.setItem("scratch_token", data.token);
    setUser(data.user);
    setCourse(data.course);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("scratch_token");
    setUser(null);
    setCourse(null);
  };

  return (
    <AppCtx.Provider value={{ user, course, loading, login, logout, isAuthed: !!localStorage.getItem("scratch_token") }}>
      {children}
    </AppCtx.Provider>
  );
}
